module.exports = __webpack_public_path__ + "static/media/btn_back5420930e2de85aa1dc995d7483938114.webp";